import { TabContext, TabPanel } from '@mui/lab';
import { Divider, FormHelperText, Grid, InputAdornment, Tab, Tabs, TextField } from '@mui/material';
import React from 'react';
import { GeneralTab } from './tabs/GeneralTab';
import { PaycodeDistributionTab } from './tabs/PaycodeDistributionTab';
import { useWorkRulesForm } from 'hooks/workRules/useWorkRulesForm';
import { useTranslation } from 'react-i18next';
import { nameValidation } from 'utils/Validations';

interface Props {
    form: ReturnType<typeof useWorkRulesForm>;
    mode: 'add' | 'edit' | 'delete' | 'info' | 'duplicate';
}

export const WorkRuleForm: React.FC<Props> = ({ form, mode }) => {
    const { t } = useTranslation();
    const { existName, form: formState, value, setValue } = form;

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                        id="name"
                        name="name"
                        label={t('settings.work_rules.fields.name')}
                        variant="outlined"
                        autoComplete="off"
                        fullWidth
                        required
                        disabled={mode === 'info'}
                        value={formState.name}
                        onChange={(e) => {
                            if (nameValidation(e.target.value)) {
                                form.update('name', e.target.value);
                                form.existName(e.target.value);
                            }
                        }}
                        error={form.existName(formState.name)}
                        slotProps={{
                            htmlInput: { maxLength: 100 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${formState.name.length}/100`}</InputAdornment>,
                            },
                        }}
                    />
                    <FormHelperText
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mt: 0.5,
                            px: 1.75,
                        }}
                    >
                        <span>{existName(formState.name) ? t('settings.work_rules.fields.exist_name') : ''}</span>
                    </FormHelperText>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                        id="description"
                        name="description"
                        label={t('settings.work_rules.fields.description')}
                        variant="outlined"
                        multiline
                        rows={2}
                        autoComplete="off"
                        disabled={mode === 'info'}
                        value={formState.description ?? ''}
                        onChange={(e) => form.update('description', e.target.value)}
                        fullWidth
                        slotProps={{
                            htmlInput: { maxLength: 255 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${(formState.description ?? '').length}/255`}</InputAdornment>,
                            },
                        }}
                    />
                </Grid>
            </Grid>

            <TabContext value={value}>
                <Tabs value={value} onChange={(event, value) => setValue(value)} variant="scrollable" scrollButtons="auto">
                    <Tab label={t('settings.work_rules.fields.tabs.tab1.title')} value={'1'} />
                    <Tab label={t('settings.work_rules.fields.tabs.tab2.title')} value={'2'} />
                </Tabs>
                <Divider />
                <TabPanel value={'1'} sx={{ p: 0, mt: 1.5 }}>
                    <GeneralTab mode={mode} form={form} />
                </TabPanel>

                <TabPanel value={'2'} sx={{ p: 0, mt: 1.5 }}>
                    <PaycodeDistributionTab mode={mode} form={form} />
                </TabPanel>
            </TabContext>
        </>
    );
};
